<template>
    <div class="main">
        <div>
            <router-link to="/view-orders"
                style="font-size:14px;width:30%;text-decoration: none;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p>
                <p>Go Back To View Order</p>

            </router-link>

            <h3 style="font-size:28px;line-height:45px">Back Order Campaign</h3>

            <div>
                <!-- <div style="background:#fbfbfb;padding: 10px;box-shadow: rgb(136 136 136 / 42%) 0px 2px 8px">
                    <a-row>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;" :span="9">
                            <a-col>
                                <div style="display:flex;justify-content: center;">
                                    <img class="img_size" src="../../assets/img/inventory_1.png"/>
                                </div>
                            </a-col>
                            <div v-if="items.statusLabel === 'Completed'">
                                <a-col style="text-align:center;padding-top:10px">
                                   <p>The products below must be shipped to fulfillment Center before this date </p> 
                                    <p style="color:green">{{ deadline}}</p>
                                    
                                </a-col>
                                
                            </div>
                            <div v-else>
                                <a-col style="text-align:center;padding-top:10px">
                                {{showCampaignDate.startDate}}  -  {{showCampaignDate.endDate}}  <span style="color:green">({{showCampaignDate.numberOfDays}})</span>
                                </a-col>
                                <a-col style="text-align:center;padding-top:10px">
                                    StartDate - EndDate
                                </a-col>
                            </div>
                            

                        </a-col>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;text-align:center" :span="7">
                            
                                <img class="img_size" src="../../assets/img/filledoutline.png"/>
                                <div style="padding-top:20px; text-align: -webkit-center;">
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === 'Pending'">
                                        
                                        <p style="font-size:12px;color:#ffb102;"> {{items.statusLabel}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === 'Live'">
                                        
                                        <p style="font-size:12px;color:rgb(23 140 20);"> {{items.statusLabel}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === `Completed`">
                                       
                                        <p style="font-size:12px;color:#41c4fd;"> {{items.statusLabel}} </p>
                                    </div>
                                </div>
                        </a-col>
                        <a-col style="height: 100px;padding: 20px;text-align:center" :span="7">
                            <img class="img_size" src="../../assets/img/cowtribe_logo.png"/>
                            <a-col style="text-align:center;padding-top:10px;font-size:20px;font-weight:bolder">
                                Ksh {{displayTotalAmount}}
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                Total Expected Revenue 
                            </a-col>
                        </a-col>
                    </a-row>
                </div> -->



                <div style="padding-top:30px;padding-bottom:30px">
                    <div style="display:flex;justify-content: space-between;margin-bottom">
                        <!-- <p>Breakdown:</p> -->
                        <div style="font-size:18px">
                            <p>Aggregate Products</p>
                        </div>
                        <div>
                            <a-button @click="showViewCampaign"
                                style="height:38px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                                icon="notification">
                                View Campaign
                            </a-button>
                            <a-button :loading="printLoading" @click="printProduct"
                                style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                icon="printer">
                                Print
                            </a-button>
                            <a-button :loading="exportLoading" @click="exportExcell"
                                style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                icon="export">
                                Export Excel
                            </a-button>
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    <a-menu-item @click="showPurchaseOrder" key="2">Purchased Orders</a-menu-item>
                                    <a-menu-item @click="showWaybills" key="3"> Waybill </a-menu-item>
                                </a-menu>
                                <a-button
                                    style="height:33px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                    icon="select">
                                    Actions <a-icon type="down" />
                                </a-button>
                            </a-dropdown>
                        </div>

                    </div>
                    <a-table :columns="columns" :data-source="tableData" :pagination="pagination"
                        :loading="tableLoading" class="productTable" @change="handleTableChange">

                        <span slot="action" slot-scope="data">
                            <div v-if="data.fulfill === 'N/A'">
                                <a-dropdown>
                                    <a style="color:#98c14b;" class="ant-dropdown-link"
                                        @click="e => e.preventDefault()">
                                        <a-icon style="font-size:25px;" type="ellipsis" />
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item>
                                            <a @click="canBeFulfill(data)">Yes</a>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <a @click="canNotBeFulfill(data)">No</a>
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </div>
                            <div v-else>
                                <div v-if="data.fulfill === 'Yes'">
                                    <a-tag color="#87d068">{{ data.fulfill }}</a-tag>
                                </div>
                                <div v-else>
                                    <a-tag color="#f50">{{ data.fulfill }}</a-tag>
                                </div>

                            </div>
                            <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                            <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                        </span>

                    </a-table>
                </div>
                <div id="printMe" style="margin-top:30px;display:none">
                    <table class="table table-striped table-hover table-bordered">

                        <thead>
                            <tr>
                                <th scope="col">Product Name</th>
                                <th scope="col">Category</th>
                                <th scope="col">Supplier</th>
                                <th scope="col">Manufacturer</th>
                                <th scope="col">Max Q'ty</th>
                                <th scope="col">Ordered Quantity</th>
                                <th scope="col">Selling Price</th>
                                <th scope="col">Cost Price</th>
                                <th scope="col">Ordered Value</th>
                                <th scope="col">Profit</th>
                                <th v-if="fulfilledProducts.length > 0" scope="col">Fullfil</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in printedProducts" :key="product.id">
                                <td>{{ product.brandName }}</td>
                                <td>{{ product.categoryName }}</td>
                                <td>{{ product.supplierName }}</td>
                                <td>{{ product.manufacturerName }}</td>
                                <td>{{ product.maxQuantity }}</td>
                                <td>{{ product.quantityOrdered }}</td>
                                <td>{{ product.sellingPrice }}</td>
                                <td>{{ product.purchasePrice }}</td>
                                <td>{{ product.revenue }}</td>
                                <td>{{ product.profit }}</td>
                                <td v-if="fulfilledProducts.length > 0">{{ product.fulfill }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import XLSX from "xlsx";

const data = [
    {
        id: 1,
        key: 1,
        brandName: "Product 1",
        categoryName: "Vaccine",
        supplierName: "Mutivet",
        revenue: 4433,
        manufacturerName: "Damsto",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    },
    {
        id: 2,
        key: 2,
        brandName: "Product 2",
        categoryName: "Vaccine 2",
        supplierName: "Mutivet 2",
        revenue: 4433,
        manufacturerName: "Damsto 2",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    },
    {
        id: 3,
        key: 3,
        brandName: "Product 3",
        categoryName: "Vaccine 3",
        supplierName: "Mutivet 3",
        revenue: 4433,
        manufacturerName: "Damsto 3",
        maxQuantity: 2333,
        quantityOrdered: 2323,
        purchasePrice: 34334,
        sellingPrice: 422,
        profit: 4343
    }
]

const columns = [

    // {
    // 	title: 'Pre-Order ID',
    // dataIndex: 'id',
    // key:"id"
    // 	// width: 200,
    // },
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name"
        //  width: 150,
    },
    {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        //  width: 150,
    },
    {
        title: 'Supplier',
        dataIndex: 'supplier',
        key: 'supplier',
        //  width: 150,
    },
    {
        title: 'Manufacturer',
        dataIndex: 'manufacturer',
        key: 'manufacturer',
        //  width: 150,
    },
    {
        title: "Max Q'ty",
        dataIndex: 'maxQuantity',
        // width: 150,
    },
    {
        title: 'Ordered Quantity',
        dataIndex: 'orderedQuantity',
        key: "orderedQuantity"
        // width: 150,
    },
    {
        title: 'Selling Price(Ksh)',
        key: 'sellingPrice',
        dataIndex: 'sellingPrice',
    },
    {
        title: 'Cost Price(Ksh)',
        key: 'costOfPrice',
        dataIndex: 'costOfPrice',
    },
    {
        title: 'Ordered Value(Ksh)',
        dataIndex: 'orderedValue',
        key: "quanorderedValuetity"
        // width: 150,
    },

    {
        title: 'Profit',
        key: 'profit',
        dataIndex: 'profit',
    },

    {
        title: 'Fullfil?',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },
];

export default {
    name: "AggregateOrders",
    // props: ['items'],
    data() {
        return {
            items: {},
            columns,
            tableData: [],
            data,
            tableLoading: false,
            pagination: {
                pageSize: 20
            },
            exportData: [],
            exportLoading: false,
            printLoading: false,
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {},
                preorderCampaignId: ""
            },
            fulfilledProducts: [],
            printedProducts: []
        };
    },
    computed: {
        ...mapGetters(['getOrder']),
        formatDateTime() {
            return moment(this.item.createdAt).format("DD-MM-YYYY HH:mm:ss A");
        },
        displayInvoiceId() {
            return this.items.id
        },

        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.action.revenue) {
                    return parseFloat(item.action.revenue)
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },

        showCampaignDate() {
            const today = moment();
            let startDate = moment(this.items.startDate).format("DD-MMM-YYYY")
            let endDate = moment(this.items.endDate).format("DD-MMM-YYYY")
            let numberOfDays = ""

            // console.log(" statusLabel | ", this.items.statusLabel)
            if (this.items.statusLabel === "Pending") {
                numberOfDays = `${moment(this.items.startDate).diff(today.format(), 'days')} days to start campaign`
            }

            if (this.items.statusLabel === "Completed") {
                numberOfDays = `${moment(today.format()).diff(this.items.endDate, 'days')} days after the end of campaign`
            }

            if (this.items.statusLabel === "Live") {
                numberOfDays = `${moment(this.items.endDate).diff(today.format(), 'days')} days at the end of campaign`
            }

            return {
                startDate: startDate,
                endDate: endDate,
                numberOfDays: numberOfDays
            }
        },
        deadline() {
            return moment(this.items.endDate).add(3, 'days').format("DD-MMM-YYYY")
        }
    },
    methods: {
        ...mapActions(['getTopProducts', 'canFulfillProduct']),
        addPreProduct() {
            this.$router.push('/new-pre-product').catch(() => { });
        },
        showPurchaseOrder() {
            this.$router.push('/purchase-order').catch(() => { });
        },
        showViewCampaign() {
            this.$router.push('/view-campaigns').catch(() => { });
        },
        showWaybills() {
            this.$router.push('/waybills').catch(() => { });
        },
        canBeFulfill(data) {
            // const tableData = [...this.tableData]
            // const productTarget = tableData.find(product => product.id === data.id)
            // if(productTarget){
            //     // console.log("productTarget |", productTarget)
            //     productTarget.action.fulfill = "Yes"
            //     this.tableData = tableData
            //     let fullProduct = productTarget
            //     fullProduct.action.fulfill = 'Yes'
            //     this.fulfilledProducts.push(fullProduct)
            // }
            // console.log("data |", data)
            let final_request = {
                data: {
                    productId: data.id,
                    quantity: data.quantityOrdered,
                    canFulfill: true
                },
                campaignId: this.items.id
            }
            // console.log("final_request |", final_request)
            this.canFulfillProduct(final_request).then(response => {
                if (response.status === 200) {
                    const tableData = [...this.tableData]
                    const productTarget = tableData.find(product => product.id === data.id)
                    if (productTarget) {
                        // console.log("productTarget |", productTarget)
                        productTarget.action.fulfill = "Yes"
                        this.tableData = tableData
                        let fullProduct = productTarget
                        fullProduct.action.fulfill = 'Yes'
                        this.fulfilledProducts.push(fullProduct)
                    }
                } else {
                    // console.log("Error | ", response)
                }
            })
        },
        canNotBeFulfill(data) {
            // const tableData = [...this.tableData]
            // const productTarget = tableData.find(product => product.id === data.id)
            // if(productTarget){
            //     // console.log("productTarget |", productTarget)
            //     productTarget.action.fulfill = "No"
            //     this.tableData = tableData
            //     let fullProduct = productTarget
            //     fullProduct.action.fulfill = 'No'
            //     this.fulfilledProducts.push(fullProduct)
            // }
            // console.log("data |", data)
            let final_request = {
                data: {
                    productId: data.id,
                    quantity: data.quantityOrdered,
                    canFulfill: false
                },
                campaignId: this.items.id
            }
            // console.log("final_request |", final_request)
            this.canFulfillProduct(final_request).then(response => {
                if (response.status === 200) {
                    const tableData = [...this.tableData]
                    const productTarget = tableData.find(product => product.id === data.id)
                    if (productTarget) {
                        // console.log("productTarget |", productTarget)
                        productTarget.action.fulfill = "No"
                        this.tableData = tableData
                        let fullProduct = productTarget
                        fullProduct.action.fulfill = 'No'
                        this.fulfilledProducts.push(fullProduct)
                    }
                } else {
                    // console.log("Error | ", response)
                }
            })
        },
        exportExcell() {
            if (this.fulfilledProducts.length === 0) {
                this.allOrderExportExcel()
            } else {
                this.exportWithFulfillment()
            }
        },
        printProduct() {
            if (this.fulfilledProducts.length === 0) {
                this.printAllProduct()
            } else {
                this.printWithFulfillment()
            }
        },
        async printAllProduct() {
            this.printLoading = true
            this.params.page = -1;
            this.params.perPage = -1;
            this.params.preorderCampaignId = this.items.id

            let response = await this.getAggregateData()

            this.printedProducts = response.map(product => ({
                brandName: product.brandName,
                categoryName: product.categoryName,
                supplierName: product.supplierName,
                manufacturerName: product.manufacturerName,
                maxQuantity: product.maxQuantity,
                quantityOrdered: product.quantityOrdered,
                sellingPrice: product.sellingPrice,
                purchasePrice: product.purchasePrice,
                revenue: product.revenue,
                profit: product.profit,
                fulfill: ''
            }))
            // console.log("printedProducts | ", this.printedProducts)
            setTimeout(() => {
                this.printLoading = false
                this.$htmlToPaper('printMe')
                // this.printedProducts = [], 
                3000 //3 secs
            });
        },

        async printWithFulfillment() {
            this.printLoading = true;
            let fulfill = this.fulfilledProducts.map(product => product.id)
            let response = await this.getAggregateData()
            let filterArray = response.filter(product => !fulfill.includes(product.id))
            this.fulfilledProducts.forEach(product => {
                filterArray.push({
                    brandName: product.action.brandName,
                    categoryName: product.action.categoryName,
                    fulfill: product.action.fulfill,
                    id: product.action.id,
                    key: product.action.key,
                    manufacturerName: product.action.manufacturerName,
                    maxQuantity: product.action.maxQuantity,
                    profit: product.action.profit,
                    purchasePrice: product.action.purchasePrice,
                    quantityOrdered: product.action.quantityOrdered,
                    revenue: product.action.revenue,
                    sellingPrice: product.action.sellingPrice,
                    supplierName: product.action.supplierName
                })
            })

            this.printedProducts = filterArray.map(product => ({
                brandName: product.brandName,
                categoryName: product.categoryName,
                supplierName: product.supplierName,
                manufacturerName: product.manufacturerName,
                maxQuantity: product.maxQuantity,
                quantityOrdered: product.quantityOrdered,
                sellingPrice: product.sellingPrice,
                purchasePrice: product.purchasePrice,
                revenue: product.revenue,
                profit: product.profit,
                fulfill: product.fulfill
            }))

            setTimeout(() => {
                this.printLoading = false
                this.$htmlToPaper('printMe')
                // filterArray = []
                // this.fulfilledProducts = []
                // this.printedProducts = [], 
                3000 //3 secs
            });
        },

        async exportWithFulfillment() {
            this.exportLoading = true;
            let fulfill = this.fulfilledProducts.map(product => product.id)
            let response = await this.getAggregateData()
            let filterArray = response.filter(product => !fulfill.includes(product.id))

            this.fulfilledProducts.forEach(product => {
                filterArray.push({
                    brandName: product.action.brandName,
                    categoryName: product.action.categoryName,
                    fulfill: product.action.fulfill,
                    id: product.action.id,
                    key: product.action.key,
                    manufacturerName: product.action.manufacturerName,
                    maxQuantity: product.action.maxQuantity,
                    profit: product.action.profit,
                    purchasePrice: product.action.purchasePrice,
                    quantityOrdered: product.action.quantityOrdered,
                    revenue: product.action.revenue,
                    sellingPrice: product.action.sellingPrice,
                    supplierName: product.action.supplierName
                })
            })
            // console.log("filterArray | ", filterArray)

            // console.log("finalData 2 | ", this.finalData)
            const dataToExport = [
                [
                    "Product Name",
                    "Category",
                    "Supplier",
                    "Manufacturer",
                    "Max Q'ty",
                    "Ordered Quantity",
                    "Selling Price",
                    "Cost Price",
                    "Ordered Value",
                    "Profit",
                    "Fullfill"
                ],
            ];

            filterArray.forEach((v) => {
                dataToExport.push([
                    v.brandName,
                    v.categoryName,
                    v.supplierName,
                    v.manufacturerName,
                    v.maxQuantity,
                    v.quantityOrdered,
                    v.sellingPrice,
                    v.purchasePrice,
                    v.revenue,
                    v.profit,
                    v.fulfill
                ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Aggregate-Products-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")
            // this.fulfilledProducts = []
            // filterArray = []
        },

        async getAggregateData() {
            this.params.page = -1;
            this.params.perPage = -1;
            this.params.preorderCampaignId = this.items.id
            let response = await this.getTopProducts(this.params)
            let data = []
            if (response.status === 200) {
                data = response.data.data;
            }
            return data
        },

        allOrderExportExcel() {

            this.exportLoading = true
            const dataToExport = [
                [
                    "Product Name",
                    "Category",
                    "Supplier",
                    "Manufacturer",
                    "Max Q'ty",
                    "Ordered Quantity",
                    "Selling Price",
                    "Cost Price",
                    "Ordered Value",
                    "Profit"
                ],
            ];
            this.params.page = -1;
            this.params.perPage = -1;
            this.params.preorderCampaignId = this.items.id

            this.getTopProducts(this.params).then(response => {

                this.exportLoading = false;
                this.params.page = 1;
                this.params.perPage = 10;
                this.params.preorderCampaignId = this.items.id
                // console.log('response in sales | ', response)
                if (response.status === 200) {

                    let results = response.data.data;

                    results.forEach((v) => {
                        dataToExport.push([
                            v.brandName,
                            v.categoryName,
                            v.supplierName,
                            v.manufacturerName,
                            v.maxQuantity,
                            v.quantityOrdered,
                            v.sellingPrice,
                            v.purchasePrice,
                            v.revenue,
                            v.profit
                        ]);
                    });

                    let wb = XLSX.utils.book_new();
                    let ws = XLSX.utils.aoa_to_sheet(dataToExport);

                    /* Add the worksheet to the workbook */
                    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                    /* generate file and send to client */
                    XLSX.writeFile(wb, `Export-Aggregate-Products-${moment().format('DD-MM-YYYY')}.xlsx`);
                    this.exportLoading = false;
                    this.showSuccessAlert("Data Successfully Exported")

                } else {
                    this.exportLoading = false;
                    console.log('Error | ', response)
                }
            },
                error => {
                    this.exportLoading = false;
                    console.log('Error | ', error)
                })
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },

        getAggregatePrder(request_data) {

            this.tableLoading = true;
            this.getTopProducts(request_data).then(response => {
                this.tableLoading = false;
                // console.log('response in sales | ', response)
                if (response.status === 200) {
                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalRecords == null ? 0 : response.data.totalRecords;
                    let results = response.data.data;

                    this.tableData = results.map(product => {
                        product.fulfill = "N/A"
                        return {
                            id: product.id,
                            key: product.id,
                            name: product.brandName ? product.brandName : "N/A",
                            category: product.categoryName ? product.categoryName : "N/A",
                            supplier: product.supplierName ? product.supplierName : "N/A",
                            orderedValue: product.revenue ? product.revenue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "N/A",
                            manufacturer: product.manufacturerName ? product.manufacturerName : "N/A",
                            maxQuantity: product.maxQuantity ? product.maxQuantity : "N/A",
                            orderedQuantity: product.quantityOrdered ? product.quantityOrdered : "N/A",
                            costOfPrice: product.purchasePrice ? product.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "N/A",
                            sellingPrice: product.sellingPrice ? product.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "N/A",
                            profit: product.profit ? product.profit.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "N/A",
                            action: product
                        }
                    })
                    this.pagination = pagination;
                } else {
                    this.tableLoading = false;
                    console.log('Error | ', response)
                }
            },
                error => {
                    this.tableLoading = false;
                    console.log('Error | ', error)
                })
        },
        handleTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination in change | ", pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.params.page = pagination.current;
            this.params.perPage = pagination.pageSize;
            this.params.preorderCampaignId = this.items.id

            this.getAggregatePrder(this.params);
        },

        loadAggregateOrders() {
            this.params.preorderCampaignId = this.items.id
            this.getAggregatePrder(this.params)
        }
    },
    created() {
        // console.log(" items in created | ", this.items);
        if (this.getOrder) {
            this.items = this.getOrder
        }

        if (this.loadAggregateOrders) {
            this.loadAggregateOrders();
        }
    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.img_size {
    max-width: 40px;
    max-height: 40px;
}

.productTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.productTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.productTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.productTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.fulfillmentTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.fulfillmentTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.fulfillmentTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.fulfillmentTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
</style>